module.exports = __webpack_public_path__ + "img/background.588db719.jpg";